import { Brand } from '@evenfinancial/even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { CommonState } from 'embed/reducers'
import { loanPurposeIsAutomobileRefinanceSelector, loanPurposeIsSLRSelector } from 'embed/selectors/application'
import { brandSelector } from 'embed/selectors/config'
import { EvenAutoRefiDisclosure, EvenPersonalLoanDisclosure, EvenSLRDisclosure } from './Even'
import { FionaAutoRefiDisclosure, FionaPersonalLoanDisclosure, FionaSLRDisclosure } from './Fiona'

interface StoreProps {
  brand?: string
  isSLR?: boolean
  isAutoRefi?: boolean
}

const LoanDisclosure: React.FC<StoreProps> = ({ brand, isSLR, isAutoRefi }) => {
  let disclosure
  if (brand === Brand.Fiona) {
    if (isSLR) {
      disclosure = FionaSLRDisclosure
    } else if (isAutoRefi) {
      disclosure = FionaAutoRefiDisclosure
    } else {
      disclosure = FionaPersonalLoanDisclosure
    }
  } else {
    if (isSLR) {
      disclosure = EvenSLRDisclosure
    } else if (isAutoRefi) {
      disclosure = EvenAutoRefiDisclosure
    } else {
      disclosure = EvenPersonalLoanDisclosure
    }
  }

  return (
    <>
      <p>
        <strong>Additional Information</strong>
      </p>
      {disclosure}
    </>
  )
}

const mapStateToProps = (state: CommonState) => ({
  brand: brandSelector(state),
  isAutoRefi: loanPurposeIsAutomobileRefinanceSelector(state),
  isSLR: loanPurposeIsSLRSelector(state),
})

export default connect(mapStateToProps)(LoanDisclosure)
